import React from 'react';
import bn from "../../utils/bemnames";

const bem = bn.create('component-wrapper');

interface IProps {
  isMobile?: boolean
  title?: string | undefined
  headerContent?: JSX.Element
}

const ComponentWrapper: React.FC<IProps> = (props) => {
  const {
    children,
    isMobile = false,
    title = null,
    headerContent = undefined
  } = props

  return (
    <div className={`${bem.b()} ${isMobile ? bem.m('mobile') : ''}`}>
      {title && (
        <div className={bem.e('title')}>
          {headerContent === undefined ? (
            <h2>{title}</h2>
          ) : headerContent}
        </div>
      )}
      <div className={(bem.e('content'))}>
        {children}
      </div>
    </div>
  )
}

export default ComponentWrapper;
